define('view/controller/booking/datetime/classes/TimeClassesServiceItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Services list item view for classes timeline
     *
     * @class TimeClassesServiceListView
     */
    return LayoutView.extend({

        template: '#time_classes_service_item_view',

        onRender: function () {
            Backbone.Wreqr.radio.vent.trigger('step:item', 'render', {
                'stepItem': 'service',
                'model': this.model,
                'view': this
            });
        }

    });

});
